import PageTitle from 'components/PageTitle';

import Section from '../components/Section';
import { InlineClippedImage } from '../components/InlineClippedImage';
import ContentTypeNav from 'components/ContentTypeNav';

import signature from '../assets/images/tg-signature.png';

import Connell_2008_Woods_and_Roses from '../assets/images/content/Connell_2008_Woods_and_Roses.jpg';
import Connell_2015_Undercurrent from '../assets/images/content/Connell_2015_Undercurrent.jpg';
import Connell_2003_Chamomile from '../assets/images/content/Connell_2003_Chamomile.jpg';
import Connell_2002_Kitchen_Tension from '../assets/images/content/Connell_2002_Kitchen_Tension.jpg';
import Connell_2002_Picnic from '../assets/images/content/Connell_2002_Picnic.jpg';
import stay_well_be_kind from '../assets/images/stay_well_be_kind.svg';
import Connell_2008_Backgammon from '../assets/images/content/Connell_2008_Backgammon.jpg';

const Q3LetterToShareholders = () => {
	return (
		<>
			<PageTitle title="Letter to Shareholders" />

			<div id="introduction" className="bg-[#D1E5DF] py-12 md:py-24">
				<div className="container max-w-[1068px]">
					<div className="md:max-w-[873px]">
						<ContentTypeNav type="letter" />
						<p className="font-late-serif text-[1.375rem] md:text-[1.65rem] leading-[1.6] mb-6">The third quarter results remain excellent, even with the September accrual related to a Florida excess profit statute (more on that below). The year-over-year (YOY) net premiums written (NPW) growth of 10% for the quarter was solid with an 89.5 combined ratio (CR), bringing the year-to-date (YTD) NPW growth to 13% YOY at an 87.3 CR. Companywide policies in force (PIF) growth remained strong, at 12% YOY. I’ll get into the details of the various business units, but first a little about the topic of Florida.</p>
					</div>
				</div>
			</div>

			<div id="leading-brand" className="py-0 md:py-24">
				<div className="grid md:grid-cols-[1fr_1fr] gap-12 container">
					<div className="grid">
						<div className="md:max-w-[520px] ml-auto">
							<p>
								As we shared in our second quarter Form 10-Q, since Florida insurance reform was enacted in 2023, we have seen lower loss costs within our personal auto business, and this has led to ongoing favorable loss reserve development. We have responded with rate reductions, but by the end of the third quarter, we concluded that it is probable our Florida personal auto underwriting profit for the three years ending December 31, 2025, will exceed the profit limit imposed by a Florida insurance statute. During September, we accrued $950 million (13.9 points of the month’s CR and 4.6 points for the quarter’s CR), which represents our current estimate of the Florida personal auto profit we will earn during the three-year period in excess of the permitted profit limit. This estimate will be refined through the end of the year. The statute requires that excess profits be returned to policyholders active as of December 31, 2025, and we expect to fund credits to
								eligible policyholders in early 2026. We applaud the reforms enacted in Florida and the more affordable rates this allows for Florida consumers.
							</p>

							<p>
								Personal Lines concluded the third quarter of 2025 with sustained growth and exceptional profitability. During the quarter, we added over 750,000 Personal Lines PIFs, achieving 13% YOY growth in PIFs at a profitable 89.5 CR. This is our sixth consecutive quarter of YOY double-digit percentage PIF growth, a remarkable accomplishment given our scale, and underscores our commitment to grow as fast as we can at or below a 96 CR. Personal Lines NPW YTD were over $55 billion and grew 16% over the previous year period. In our personal vehicles business (auto and special lines), we grew PIFs 13% YOY and for the quarter NPW grew 12% YOY at a CR of 90.7, well below seasonal CR targets. In the personal property business, favorable weather and ongoing initiatives to mitigate risk in areas susceptible to volatile weather, coupled with favorable prior year development, contributed to an extraordinarily low third quarter CR of 63.5. With our continued focus on
								profitable growth in the third quarter, we processed over 4.1 million Personal Lines new applications, marking our highest quarter of the year. In the direct channel we heavily advertised through multiple media platforms, while in the agency channel we continued to offer a variety of incentives and rewards to our agents to incent incremental growth. Across all products we seek to deliver our most competitive rates to consumers, monitor loss trends and continuously evaluate both rate and non-rate actions. Operationally, we continued to manage our non-acquisition costs and YTD our personal vehicles non-acquisition expense ratio, excluding the impact of the Florida policyholder credit, decreased 0.1 points compared to the prior year.
							</p>
						</div>
					</div>
					<div className="md:max-w-[583px] ml-auto">
						<div>
							<InlineClippedImage
								src={Connell_2008_Woods_and_Roses}
								alt="Art"
								dimensions={{
									width: 1920,
									height: 1440,
								}}
								clipPaths={[
									{
										initial: {
											x: '45%',
											y: '3%',
											width: '45%',
										},
										expanded: {
											x: '0%',
											y: '0%',
											width: '100%',
										},
									},
								]}
							/>
						</div>
					</div>
				</div>
				<div className="grid md:grid-cols-[1fr_1fr] gap-12 container">
					<div className="grid">
						<div className="md:max-w-[520px] ml-auto mt-12 md:mt-0">
							<p>Personal auto continued to demonstrate very robust growth and profitability with a YOY PIF increase of 15%, at an exceptional quarterly CR of 90.4. Written premium growth for the quarter was 13%, compared to the third quarter last year, primarily driven by strong renewals of our existing policyholders. Year-over-year, auto shopping remains elevated and conversion rates were consistent with prior quarters, indicating our rates remained competitive. We have initiated rate decreases in select markets where margins allow, but overall countrywide rates remain relatively stable.</p>
						</div>
						<div className="md:max-w-[583px] mx-auto mt-12 md:mt-auto">
							<InlineClippedImage
								src={Connell_2015_Undercurrent}
								alt="Art"
								dimensions={{
									width: 1920,
									height: 1440,
								}}
								clipPaths={[
									{
										initial: {
											x: '55%',
											y: '26%',
											width: '40%',
										},
										expanded: {
											x: '0%',
											y: '0%',
											width: '100%',
										},
									},
								]}
							/>
						</div>
					</div>
					<div>
						<div className="md:max-w-[520px]">
							<p>At the end of the third quarter 2025, personal auto product model 8.9 is available in 26 states, that represent 50% of PIFs and 47% of auto NPW on a trailing 12-month basis. This model continues to demonstrate favorable conversion and elasticity. Our latest product offering, model 9.0, is elevated in one state and four additional states are scheduled to elevate in October. Additionally, at the end of the third quarter 2025, our Snapshot ® 5.0 model, which features an app-based tool capable of detecting major accidents and promptly connecting customers to towing and emergency services, was deployed in 42 states that represent 78% of NPW on a trailing 12-month basis (excluding California).</p>

							<p>Our personal property business posted another solid quarter, as we experienced relatively mild weather combined with favorable prior accident year development. We ended the quarter with over 3.6 million PIFs, up 6% over third quarter 2024, driven primarily by growth in our renters business. Net premiums written increased 5% for the quarter YOY, slightly lower than PIF growth, driven by a continued mix shift towards renters policies, which have lower average written premiums.</p>

							<p>We continue to prioritize insuring lower-risk properties (e.g., new construction, existing homes with new roofs) and only accepting new business when bundled with a Progressive personal auto policy (where allowed). We continue to work on balancing risk in our personal property book by reducing exposure in catastrophe-prone markets and shifting mix towards lower volatile weather-related areas. During the third quarter YOY, homeowners PIFs increased 2% in markets where we want to increase share and decreased 15% in volatile weather markets.</p>
						</div>
					</div>
				</div>
			</div>

			<div className="container py-0 md:py-24">
				<img src={stay_well_be_kind} alt="stay_well_be_kind" className="" />
			</div>

			<Section backgroundColor="#F1F7F6">
				<div className="md:grid md:grid-cols-[1fr_1fr] gap-12 px-4 sm:px-6">
					<div className="md:max-w-[520px] ml-auto ">
						<p>We continue to make good progress on advancing our personal property product and segmentation capabilities. Through the end of the third quarter 2025, we elevated our next generation 5.0 or higher product models in 35 states that represent over 80% of our trailing 12-month homeowners product NPW. Key features of 5.0+ models include expanded peril rating and introduction of new rating variables. We also continued to adjust rates where needed and, during the third quarter, we increased our personal property rates about 2% overall, bringing our YTD increase to about 8%.</p>
					</div>
				</div>
				<div className="md:grid md:grid-cols-[1fr_1fr] gap-12 px-4 sm:px-6">
					<div className="md:max-w-[520px] ml-auto">
						<p>For the third quarter, the Commercial Lines (CL) business grew PIFs 6% YOY at an 89.2 CR. Despite positive PIF growth, NPW decreased 6% in the quarter, compared to the prior year quarter, driven primarily by a decline in transportation network company (TNC) premiums, which were lower in the quarter due to changes in mileage forecasts and mileage true-ups. To a lesser extent, a shift to a greater mix of policies with 6-month terms, compared to 12-month terms, in our contractor and business auto business market targets (BMT) and a mix shift to lower average written premium BMTs in our core commercial auto business, also contributed to the NPW decrease for the quarter. Excluding the TNC business, our total CL NPW for the quarter would have decreased 2%, compared to the third quarter 2024. </p>
					</div>
					<div className="md:max-w-[520px] grid">
						<div className="mt-auto">
							<p>In core commercial auto, we continued to see strong PIF growth in our business auto and contractor BMTs during the third quarter 2025. We also continued to face PIF growth challenges in our for-hire transportation, and to a lesser extent, our for-hire specialty BMTs, each of which have higher average written premiums per policy than our business auto and contractor BMTs. The resulting mix shift to lower average written premium segments drove lower NPW for core commercial auto during the quarter compared to the prior year quarter.</p>

							<p>We continue to roll out our newest core commercial auto product offering, model 8.3, which brings new external data that we expect will improve segmentation and better match rate to risk. As of the end of the third quarter 2025, the 8.3 model was elevated in 10 states, with plans to elevate in an additional state by the end of 2025, pending regulatory approval. Those 11 states represent 43% of our countrywide trailing 12-month core commercial auto NPW.</p>
						</div>
					</div>
				</div>
			</Section>

			<div>
				<div className="grid grid-cols-1 gap-4 items-stretch mt-24 mb-8 md:grid-cols-3">
					<img src={Connell_2003_Chamomile} alt="Connell_2024_Still_Summer" className="w-full h-auto" />
					<img src={Connell_2002_Kitchen_Tension} alt="Connell_2002_Kitchen_Tension" className="w-full h-auto" />
				</div>
				<div className="md:grid md:grid-cols-[56%_1fr] gap-12">
					<div className="md:max-w-[534px] order-1 ml-auto py-12 px-4 sm:px-6">
						<p>In the third quarter 2025, our investment portfolio saw a return of 1.7% and remained in a relatively conservative posture. Our fixed-income portfolio returned 1.5%, while our equity portfolio returned 8.1%, contributing to portfolio total returns of 6.1% through the first nine months of 2025.</p>

						<p>
							The robust comprehensive income that we have generated throughout this year is more than the amount necessary to support our growth expectations in our operating business. We finished the third quarter 2025 with our financial leverage at 16.3% and have no bond maturities until 2027. We will continue to attempt to strike a balance between maintaining the competitive advantage of being in such a strong financial position while seeking capital efficiency. As is our defined annual process, the Board of Directors will consider an annual-variable dividend at its regularly scheduled meeting in December. Our focus, as a management team, remains on driving strong returns on our shareholders’ capital over the longer term. One element of that focus is a thoughtful share repurchase policy that has two parts. The first part seeks to ensure that we annually repurchase enough shares to prevent dilution caused by employee stock grants. The second part allows us to
							repurchase shares when we believe that Progressive stock is being valued by the market either at or below our view of long-term fair value.
						</p>
					</div>
				</div>
				<div className="md:grid md:grid-cols-[56%_1fr] gap-12 px-4 sm:px-6">
					<div className="order-1 md:grid">
						<div className="md:max-w-[563px] h-[422.25px] mr-auto">
							<InlineClippedImage
								src={Connell_2008_Backgammon}
								dimensions={{
									width: 1920,
									height: 1440,
								}}
								clipPaths={[
									{
										initial: {
											x: '56%',
											y: '4%',
											width: '38%',
										},
										expanded: {
											x: '0%',
											y: '0%',
											width: '100%',
										},
									},
								]}
							/>
						</div>
					</div>
					<div className="max-w-[550px] order-2 mr-auto">
						<p>As many of you know, I love wrapping up these letters with a few short stories about Progressive people that exemplify what I consider to be our one-of-a-kind culture. It’s a culture where, regardless of circumstance, we all work together toward our shared purpose: helping others move forward and live fully.</p>

						<p>Bonnie, an administrative assistant from one of our upstate New York Claims offices, had just stopped at her favorite coffee shop on her way to work when another car zoomed by and veered over an embankment without slowing. She immediately turned around and tracked the car down—it had crashed into a tree near a cornfield, and the front end had caught fire. While other bystanders stood in shock wondering what to do, Bonnie sprang into action, eventually wrenching one of the car’s back doors open and dragging the semi-conscious driver out of the burning vehicle. Afterward, Bonnie played down the incident, saying only that if it had been her or someone she knew, she would have wanted someone to help. Talk about helping others move forward and live fully!</p>

						<p>
							We win a lot of workplace awards around the country because of our culture, and one of these really stood out to me. Three of our employees, Tonya, Elisha, and Nestor, were interviewed for a local news article about an award, and their quotes were just so genuine and so … Progressive, that they just jumped off the page, like this one, from Tonya:
							<span className="text-[#4B7B9D] font-late-serif"> &ldquo;Our Core Values aren’t just words on paper; we’re shaped by them. What I love the most is our strong sense of community, the feeling of inclusivity. It’s something you sense throughout the entire organization. I’m definitely a Progressive lifer; I intend on retiring here.&rdquo;</span>
						</p>

						<p>
							Or this one, from Elisha:
							<span className="text-[#C9B815] font-late-serif"> &ldquo;We want our employees to be happy; we want them to stay. Progressive fosters an environment where you can be your true self.&rdquo;</span>
						</p>

						<p>
							And finally this one, from Nestor:
							<span className="text-[#F05860] font-late-serif"> &ldquo;Our job is collaborative, very nurturing. When you see someone else, lend an ear. It allows people to bond. It’s a ton of fun. It’s highly technical, highly regulated, but people lift each other up. We embrace the experience we’re all kind of going through at the same time.&rdquo;</span>
						</p>

						<p>
							And to close this out on a lighter note, here’s a little story about cookies. Cookies by Freddie is one of the recipients of the Commercial Lines business’ Driving Small Business Forward grant. The owner wrote to us, saying:
							<span className="text-[#767727] font-late-serif"> &ldquo;To know that the joy I find in baking and my mission to spread happiness through Cookies by Freddie resonated with you means more than I can fully express. Your recognition not only affirms the heart behind my business, but it also fuels my determination to continue creating memorable, comforting experiences. One cookie at a time.&rdquo;</span>
						</p>

						<p>Speaking of awards, we recently received the results of our annual Gallup survey and I am extraordinarily proud to announce that we ranked in the 99th percentile of Gallup-surveyed companies. Our participation was a record high, our engagement increased, and every index showed improvement over already stellar results. This doesn’t come without a lot of people who care deeply about living our Core Values and treating each other and our customers with care and respect.</p>

						<p>This year, like last, has been one of growth with solid margins. As we head into the final quarter, we remain steadfast in fulfilling our Vision and Purpose.</p>

						<p className="mb-6">Stay well and be kind to others,</p>
						<img src={signature} className="max-w-[255px]" alt="" />
						<p>
							Tricia Griffith <br /> President and Chief Executive Officer
						</p>
					</div>
				</div>
			</div>

			<div className="container grid py-24">
				<div className="max-w-[1114px] mr-auto">
					<InlineClippedImage
						src={Connell_2002_Picnic}
						dimensions={{
							width: 1920,
							height: 1440,
						}}
						clipPaths={[
							{
								initial: { x: '51%', y: '5%', width: '44%' },
								expanded: { x: '0%', y: '0%', width: '100%' },
							},
						]}
					/>
				</div>
			</div>
		</>
	);
};

export default Q3LetterToShareholders;
